/**
 * Created by joerg on 20.05.17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Utils from '../utils/Utils';
import {Route, Link} from 'react-router-dom'
import InputComponent from '../components/InputComponent';
import OutPutComponent from '../components/OutPutComponent';
import InputModel from '../models/InputModel'
import DropDown from '../components/DropDown'



@observer
export default class ErrorTexts extends React.Component {

    _onChange(e,entry){
        console.log('ch',e.target.value,entry)
        entry.value = e.target.value;
    }
    componentDidUpdate(){
        setTimeout(()=>{requestAnimationFrame(this._calcwidths);},200);

    }
    componentDidMount(){
        this.componentDidUpdate();
    }
    _calcwidths(){
       // console.log('calcwidth')

        Utils.normalizeAddonWidths('#basedicken')



    }

    render (){
        const {baseDataStore,brespaDataStore} = this.props;
      //  const self = this;
        //console.log("entfcomp",baseDataStore.entfernungcomp.value)
        var z = 200;
        var showtxt = (baseDataStore.dickeforderlichob.value - brespaDataStore.plattendicke.value > 8);
        if(baseDataStore.isPossible.possible == false){
            return <div id="errtxte" className='alert alert-danger' >
                <h4>Achtung</h4>
                <p dangerouslySetInnerHTML={{__html:(baseDataStore.isPossible.reasons.indexOf("2") >= 0)?"Ein Transport von BRESPA®-Decken von Schneverdingen aus ist bis zum Bauort ökonomisch wie ökologisch nicht sinnvoll. " +
                    "Bitte ändern Sie die Postleitzahl, um das Programm fortzusetzen. Bei konkreten Projekten nehmen Sie gerne mit uns Kontakt auf: <a href='mailto:info@dw-systembau.de'>info@dw-systembau.de</a>":""}}>

                 </p>
                <p>
                    {(baseDataStore.isPossible.reasons.indexOf("1") >= 0)?"Das Programm ist für Geschosswohnungsbauprojekte ab einer Gesamtdeckenfläche von 500 m² konzipiert. " +
                        "Ändern Sie bitte die Geschossigkeit oder die Gebäudeabmessungen.":""}
                </p>
            </div>;
        }
        if(showtxt){
            let txt0 = 'Diese Stützweiten sind für Halbfertigteile und Ortbetondecken unwirtschaftlich.';
            let txt1 = 'Wir fügen die zusätzlich erforderlichen statischen Deckenauflager zum Preis von ';
            let txt2 = ' hinzu so dass die Deckendicken denen der BRESPA®-Decken entsprechen und die Mehrkosten der zusätzlichen Deckenauflager auf die m²-Preise umgelegt und unter Kosten und Ergebnisse separat ausgewiesen werden.' +
                'Sie können entweder das ';
            return  <div id="errtxte" className='alert alert-danger' >
                <h4>Achtung</h4>

                <div>{txt0}<br/>{txt1}<Link to={`/${Utils.serverpath}/brespa`}>{baseDataStore.kosten_stuetzung.value + ' ' + baseDataStore.kosten_stuetzung.einheit}</Link>{txt2}
                    <div key={baseDataStore.strukturAuswahl.key} className="form-group zup" style={{zIndex : z}}>
                        <div className="input-group size-input-height" style={{width:'100%'}} >
                            <div className="input-group-addon left-addon-dd" dangerouslySetInnerHTML={{__html: baseDataStore.strukturAuswahl.title}}></div>
                            <div className="input-group-btn ">
                                <DropDown key={baseDataStore.strukturAuswahl.key} dataProvider={baseDataStore.strukturAuswahl} onSelect={baseDataStore.strukturAuswahl.onSelect}/>
                            </div>
                        </div>
                    </div>
                    {' oder die '}
                    <Link to={`/${Utils.serverpath}/brespa`}>{'Kosten pro lfdm Deckenauflager ändern'}</Link>
                </div>

            </div>
        }
        return "";
    }

}

ErrorTexts.propTypes = {
    baseDataStore: PropTypes.object.isRequired,
    brespaDataStore: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/components/ErrorTexts.js